<template>
  <v-container v-if="!review">
    <div class="text-h4">How many IP addresses do you need?</div>
    <v-select
      label="IP Addresses Requested"
      :value="currentIPs()"
      persistent-hint
      readonly
      :hint="ipHint"
      :items="ipOptions"
      @input="setCurrentIps"
    ></v-select>
  </v-container>
  <div v-else>
    <ReviewItem
      label="How many IP addresses do you need?"
      :exludeValidation="true"
      :value="currentIPs()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ReviewItem from '@/components/ReviewItem.vue';

export default {
  name: 'ips',
  props: {
    review: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      ipHint: `If more than 5 IP addresses are requested 123.Net will require
        an IP justification form to be filled out. IPv6 Addresses are
        available by request. If BGP, include ASN and IPs in notes.
      `,
      ipOptions: [
        {
          value: 1,
          text: "1 (/30)",
        },
        {
          value: 5,
          text: "5 (/29)",
        },
        {
          value: 13,
          text: "13 (/28)",
        },
        {
          value: 29,
          text: "29 (/27)",
        },
        {
          value: 61,
          text: "61 (/26)",
        },
        {
          value: 125,
          text: "125 (/25)",
        },
        {
          value: 253,
          text: "253 (/24)",
        },
        {
          value: 'existing',
          text: "Existing",
        },
      ],
    };
  },
  methods: {
    ...mapActions(['updateStoreFormData']),
    setCurrentIps(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'ips',
      });
    },
  },
  computed: {
    ...mapGetters(['getProductSelected', 'getFormData', 'getProductIdSelected', 'productSpeed', 'currentIPs']),
  },
  components: {
    ReviewItem,
  },
};
</script>
